import { render, staticRenderFns } from "./QueueCreate.vue?vue&type=template&id=f9633702&"
import script from "./QueueCreate.vue?vue&type=script&lang=js&"
export * from "./QueueCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports